export default "__VITE_ASSET__CTeyxVpV__"